import { PropsOnlyChildren } from '@domain/types/prop.types';
import { useParams } from 'react-router-dom';
import { getGameInfoByUrlId } from '@data/game.infos';
import GameSelectionContext from '@domain/game.selection/game.selection.context';
import React from 'react';

interface GameSelectionProviderParams {
  gameUrlId: string;
}

export const GameSelectionProvider = ({ children }: PropsOnlyChildren) => {
  const { gameUrlId } = useParams<GameSelectionProviderParams>();
  const game = getGameInfoByUrlId(gameUrlId);
  return <GameSelectionContext.Provider value={game}>{children}</GameSelectionContext.Provider>;
};
